import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    GroupPanel,
    Grouping,
    Format,
    Pager,
    Summary,
    GroupItem,
    SortByGroupSummaryInfo
} from 'devextreme-react/data-grid';
import Request from "../../components/Request/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import './HizmetForm.scss';
import CustomStore from 'devextreme/data/custom_store';

import TextBox from 'devextreme-react/text-box';
import FileUploader from 'devextreme-react/file-uploader';
import * as AppActions from '../../actions/AppActions';

const HizmetForm = (props) => {

    const dispatch = useDispatch();

    const listeBasligi = "Hizmet Form ";
    const [store, setStore] = useState(null);
    const inputOpenFileRef = React.createRef();
    const [tcKimlikNo, setTcKimlikNo] = useState("");

    useEffect(() => {
        setStore(getStore());
    }, [])

    useEffect(() => {
        if (tcKimlikNo && tcKimlikNo.length == 11) {
            setStore(getStore());
        }

    }, [tcKimlikNo])

    const getStore = () => {
        return new CustomStore({
            key: 'id',
            useDefaultSearch: false,
            load: function (loadOptions) {

                if (!tcKimlikNo || tcKimlikNo.length == 0) {
                    return [];
                }
                const request = new Request("/emeklilik-app/api/personel-calisma-detay/getListByTcKimlikNo/" + tcKimlikNo, "GET", null, "application/json");
                //   const request = new Request("/api/personel-calisma-detay/getListByTcKimlikNo/" + tcKimlikNo, "GET");
                return request.run()
                    .then(response => {
                        if (response.data) {


                            return {
                                data: response.data.data,
                                totalCount: response.data.total,
                                summary: 0,
                                groupCount: 0
                            };
                        } else {
                            return []

                        }
                    });
            }
        });
    }


    function uploadFile(e) {

        if (inputOpenFileRef) {
            //inputOpenFileRef.current.instance.reset("valueChanged");
            inputOpenFileRef.current.instance._$fileInput.val("")
            inputOpenFileRef.current.instance._isCustomClickEvent = true
            inputOpenFileRef.current.instance._$fileInput[0].click();
            inputOpenFileRef.current.instance._eventsStrategy._events.valueChanged = null;
            inputOpenFileRef.current.instance.on("valueChanged",
                (e1) => {
                    let fileExtensionXml = e1.value[0].name.substring(e1.value[0].name.length - 4);
                    let fileExtensionXlsx = e1.value[0].name.substring(e1.value[0].name.length - 5);
                    let fileExtensionTxt = e1.value[0].name.substring(e1.value[0].name.length - 4);
                    if (fileExtensionXml.toUpperCase() === ".PDF") {
                        dosyaYukle(e1.value[0]);
                    } else {

                    }
                })
        }

    }

    function dosyaYukle(file) {

        const formData = new FormData();
        formData.append('file', file);
        dispatch(AppActions.setLoading(true, "Dosya Yükleniyor.."));
        const request = new Request("/emeklilik-app/api/pdf-parser/saveDosya", "POST", formData, "multipart/form-data");
        //  const request = new Request("/api/pdf-parser/saveDosya", "POST", formData, "multipart/form-data");
        request.run().then((response) => {
            if (response && response.data) {
                setTcKimlikNo(response.data.tcKimlikNo);
            }
            dispatch(AppActions.setLoading(false, ""));
        });

    }
    const yenile = () => {
        setStore(getStore());
    }
    function textValueChanged(data) {
        //loginInfo.name = data.value;
        setTcKimlikNo(data.value);
        //setLoginInfo(loginInfo);
    }

    return (
        <div >
            <h2 className={'dx-icon-product'} >{listeBasligi}</h2>
            <div className="dx-field">
                <div className="buttons" align={'left'} style={{ marginLeft: "10px" }}>

                    <TextBox defaultValue=""
                        stylingMode="filled"
                        showClearButton={true}
                        valueChangeEvent="keyup"
                        onValueChanged={textValueChanged} />

                    <Button icon="plus" width={150} text="Yenile" type={'success'} style={{ fontSize: "15px" }} onClick={yenile}></Button>

                    <Button
                        icon="upload"
                        width={200}
                        text="Pdf Dosya Yükle"
                        type={'success'}
                        style={{ fontSize: "15px" }}
                        onClick={uploadFile}
                    />

                    <FileUploader
                        ref={inputOpenFileRef}
                        selectButtonText=""
                        labelText=""
                        visible={false}
                        accept={'.pdf'}
                        allowedFileExtensions={['.pdf']}
                        uploadMode="useForm" />

                </div>
            </div>
            <DataGrid
                className="cariDonemRaporGridlist"
                width="100%"
                dataSource={store}
                key="id"
                keyExpr="id"
                showBorders={true}
                focusedRowEnabled={true}
                allowColumnResizing={true}
                columnResizingMode={"widget"}
                columnAutoWidth={false}
            >
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={true} />
                <FilterRow visible={true} />
                <Export enabled={true} />
                <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                <Paging defaultPageSize={1000} />
                <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                {/* <Column dataField={'id'} width={90} caption={'Id'} visible={false} /> */}
                <Column dataField={'donem'} width={90} caption={'Dönem'} />
                <Column dataField={'sigortaKolu'} width={90} caption={'Sigorta Kolu'} />
                <Column dataField={'sigortaStatu'} width={120} caption={'Statü'} />
                <Column dataField={'belgeTuru'} width={90} caption={'Belge Türü'} />
                <Column dataField={'firma.unvan'} width={90} caption={'Firma'}/>
                <Column dataField={'firma.kurumNo'} width={90} caption={'KurumNo'} />
                <Column dataField={'adiSoyadi'} width={150} caption={'Detay Adı Soyadı'} />
                <Column dataField={'personel.adiSoyadi'} width={150} caption={'Adı Soyadı'} />
                <Column dataField={'personel.tcKimlikNo'} width={120} caption={'TcKimlikNo'}  groupIndex={0}  />
                <Column dataField={'personel.emekli'} width={50} caption={'Emekli'} />


                <Column dataField={'girisTarihi'} width={120} caption={'Giriş Tar.'} dataType="date" format="yyyy-MM-dd" />
                <Column dataField={'cikisTarihi'} width={120} caption={'Çıkış Tar.'} dataType="date" format="yyyy-MM-dd" />
                <Column dataField={'gun'} width={90} caption={'Gün'} />
                <Column dataField={'pek'} width={120} caption={'Pek'} dataType="number" format={"#,##0.00"} />

                <Column dataField={'egn'} width={90} caption={'Egn'} />
                <Column dataField={'icn'} width={90} caption={'ICN'} />
                <Column dataField={'meslekKodu'} width={90} caption={'MeslekKodu'} />
                <Column dataField={'kademeDereceBasamak'} width={90} caption={'Derece-Basamak'} />
                <Column dataField={'belgeTuru'} width={90} caption={'Belge Türü'} />
                {/* <Column dataField={'personelCalisma.girisTarihi'} width={120} caption={'Giriş Tar.'} dataType="date" format="yyyy-MM-dd" defaultSortOrder="desc"  /> */}


                <Column dataField={'personel.toplamGun'} width={50} caption={'Firmada Toplam Gün'} />

                <Summary  >
                    <GroupItem
                        column="gun"
                        summaryType="sum"
                        valueFormat="decimal"
                        displayFormat="Toplam: {0}"
                        showInGroupFooter={true} />
                    <GroupItem
                        column="pek"
                        summaryType="sum"
                        valueFormat="currency"
                        // precision={2}
                        displayFormat="Toplam: {0}"
                        showInGroupFooter={true}
                        format={{ type: "fixedPoint", precision: 2 }} />
                </Summary>
                <SortByGroupSummaryInfo summaryItem="count" />
            </DataGrid>

        </div>
    )
}

export default HizmetForm;
